/*
 * For use with _address_autocomplete.html template
 */
import Cookies from 'js-cookie';
import { Sentry } from "./sentryInstrument";
window.initMap = function() {};

async function updateAutocompleteDigest(digestField) {
  if (!digestField) {
	return;
  }
  let digest = digestField.value;
  const data = new FormData(digestField.closest("form"));
  if (!data.has("csrftoken")) {
	data.append("csrftoken", Cookies.get("csrftoken"));
  }
  try {
	const response = await fetch("/geo/_api/address-autocomplete-digest/", {
	  method: "POST",
	  body: data,
	});
	digest = await response.json();
  } catch(error) {
	console.error("Failed to obtain autocomplete digest:", error);
	Sentry.captureException(error, {stage: "get autocomplete digest"});
	return;
  }
  digestField.value = digest;
}

export function autocompleteRegion(components, regionSelect, digestField) {
  let administrativeArea;
  const administrativeAreaFields = Object.keys(components).filter(k => k.startsWith("administrative_area")).sort();
  if (administrativeAreaFields.length) {
	administrativeArea = components[administrativeAreaFields[0]];
  } else {
	console.error("No region data from autocomplete");
	return;
  }
  const regionName = administrativeArea.long_name;
  const regionCode = administrativeArea.short_name.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  const simplifiedRegionName = administrativeArea.long_name.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  const regionCodeMatch = regionSelect.querySelector(`option[value="${regionCode}"]`) || regionSelect.querySelector(`option[value="${regionName}"]`) || regionSelect.querySelector(`option[value="${simplifiedRegionName}"]`);
  if (regionCodeMatch === null) {
	const option = new Option(regionName, simplifiedRegionName, true);
	regionSelect.add(option);
	regionSelect.querySelector(`option[value="${simplifiedRegionName}"]`).selected = true;
  } else {
	regionCodeMatch.selected = true;
  }
  updateAutocompleteDigest(digestField);
}
window.autocompleteRegion = autocompleteRegion;

export function changeInputValue(input, value) {
  input.value = value;
  input.dispatchEvent(new Event("change"));
}
window.changeInputValue = changeInputValue;

